var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { NavigatorProvider, useNavigator } from 'hx-navigator';
import { useSyncFormWithStore } from 'hx-wizard';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { wizardActions } from '@/store';
import { PerceivedHearingStatusSelect } from '@/components/perceived-hearing-status-select.component';
import { StepLayout } from '@/components/step-layout.component';
import { VolumeSelect } from '@/components/volume-select.component';
import { InformationToggle } from '@/components/information-toggle.component';
import { HeadphonesTip } from '@/components/headphones-tip.component';
import { pageImages } from '@/pages/images';
import { useAnalytics } from 'hx-analytics';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { sendScrollIntoView } from '@/helpers/send-scroll-into-view.helper';
import { palette } from '@/theme/palette';
var womanWithHeadphones2 = pageImages.womanWithHeadphones2, manWithHeadphones2 = pageImages.manWithHeadphones2, womanWithHeadphones3 = pageImages.womanWithHeadphones3;
export function SetupPage() {
    var form = useForm({ defaultValues: { volume: 50 } });
    var dispatch = useDispatch();
    useSyncFormWithStore(form, ['wizard', 'form'], wizardActions.update);
    var navigator = useNavigator({
        onComplete: function () { return dispatch(wizardActions.sendData()); },
    });
    return (_jsx(FormProvider, __assign({}, form, { children: _jsx(NavigatorProvider, __assign({}, navigator, { children: _jsx("form", __assign({ onSubmit: form.handleSubmit(function () {
                    navigator.next();
                    sendScrollIntoView();
                }) }, { children: _jsx(Outlet, {}) })) })) })));
}
export var PerceivedHearingStatusStep = function () {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var heading = 'Do you think you have a hearing problem?';
    return (_jsx(StepLayout, { progress: { phase: 0, step: 1 }, image: womanWithHeadphones2, heading: isMobile ? heading : '', headingComponent: _jsx(Typography, __assign({ align: 'center', className: 'text-white text-2xl' }, { children: _jsx("strong", __assign({ className: "block" }, { children: heading })) })), content: _jsx(PerceivedHearingStatusSelect, {}), nav: _jsx(NavigationButtonsContainer, __assign({ className: 'pb-6 pt-4' }, { children: _jsx(NavigationButton, __assign({ navigate: "/before-you-start" }, { children: "Previous" })) })) }));
};
export var InfoStep = function () { return (_jsx(StepLayout, { progress: { phase: 0, step: 2 }, image: manWithHeadphones2, content: _jsx(HeadphonesTip, {}) })); };
export var VolumeStep = function () {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var sendButtonClick = useAnalytics().sendButtonClick;
    var heading = 'Adjust the volume to a comfortable listening level.';
    return (_jsx(StepLayout, { progress: { phase: 0, step: 3 }, image: womanWithHeadphones3, heading: isMobile ? heading : '', headingComponent: _jsx(Typography, __assign({ align: 'center', className: 'text-white text-2xl' }, { children: _jsx("strong", __assign({ className: "block" }, { children: heading })) })), content: _jsx(VolumeSelect, {}), info: _jsx(InformationToggle, __assign({ title: "What is a comfortable listening level?", chevronColor: palette.primary.main, onClick: function () { return sendButtonClick('what_is_comfortable_hearing_level'); } }, { children: _jsx(Typography, { children: "Please find a comfortable listening level somewhere near the middle of your volume range. You should be able to clearly hear words being spoken. Setting the volume levels \u201Ctoo loud\u201D or \u201Ctoo soft\u201D will risk the accuracy of your assessment results. Somewhere in the middle is best." }) })) }));
};
